import React from 'react';
import { Briefcase, Server, Cloud, Users, CheckCircle } from 'lucide-react';
import ServicePage from './ServicePage';

const professionalServicesData = {
  title: "Professional IT Services",
  description: "Expert IT solutions for your business transformation needs. From infrastructure design to cloud migration, we deliver results that drive success.",
  features: [
    {
      icon: Cloud,
      title: "Cloud Solutions",
      description: "Complete cloud transformation services",
      details: [
        "Cloud migration strategy",
        "Infrastructure optimization",
        "Cloud security implementation",
        "Performance monitoring"
      ]
    },
    {
      icon: Server,
      title: "Infrastructure Design",
      description: "Custom infrastructure solutions",
      details: [
        "Network architecture",
        "System integration",
        "Scalability planning",
        "Disaster recovery"
      ]
    },
    {
      icon: Users,
      title: "Project Management",
      description: "Expert IT project delivery",
      details: [
        "Project planning",
        "Resource allocation",
        "Risk management",
        "Quality assurance"
      ]
    }
  ],
  stats: [
    {
      icon: Briefcase,
      value: "500+",
      label: "Projects Completed"
    },
    {
      icon: Users,
      value: "98%",
      label: "Client Satisfaction"
    },
    {
      icon: Cloud,
      value: "100%",
      label: "Cloud Success Rate"
    },
    {
      icon: Server,
      value: "15+",
      label: "Years Experience"
    }
  ],
  process: [
    {
      number: 1,
      title: "Discovery",
      description: "Understanding your needs"
    },
    {
      number: 2,
      title: "Planning",
      description: "Detailed solution design"
    },
    {
      number: 3,
      title: "Execution",
      description: "Expert implementation"
    },
    {
      number: 4,
      title: "Support",
      description: "Ongoing maintenance"
    }
  ],
  pricing: [
    {
      title: "Project-Based",
      price: "Custom",
      description: "Tailored to project scope",
      features: [
        "Dedicated Project Manager",
        "Expert Implementation Team",
        "Project Documentation",
        "Knowledge Transfer"
      ]
    },
    {
      title: "Managed Projects",
      price: "From $10,000",
      description: "End-to-end project management",
      features: [
        "Everything in Project-Based",
        "Resource Management",
        "Risk Mitigation",
        "Regular Reporting",
        "Quality Assurance"
      ],
      recommended: true
    },
    {
      title: "Enterprise",
      price: "Custom",
      description: "Complex enterprise solutions",
      features: [
        "Everything in Managed",
        "Enterprise Architecture",
        "Program Management",
        "Strategic Planning",
        "Executive Support"
      ]
    }
  ],
  testimonials: [
    {
      quote: "UCX delivered our cloud migration project on time and under budget. Their expertise was invaluable.",
      author: "Thomas Anderson",
      role: "CIO",
      company: "Global Systems Inc"
    },
    {
      quote: "Their professional services team showed exceptional skill in handling our complex infrastructure upgrade.",
      author: "Lisa Zhang",
      role: "IT Director",
      company: "Tech Solutions Ltd"
    },
    {
      quote: "The level of professionalism and technical expertise exceeded our expectations.",
      author: "Richard Moore",
      role: "Operations Manager",
      company: "Enterprise Corp"
    }
  ]
};

export default function ProfessionalServices() {
  return <ServicePage {...professionalServicesData} />;
}